import React from "react";
import { Button } from "antd";
import BasicModal from "../../ui/BasicModal/BasicModal";

// Confirmation step before refunding a transaction. Mirrors the BuyFundsModal
// layout (same title/description/actions classes) so the two modals read as a
// matched pair; only the confirm button is restyled to signal the refund action.
const RefundConfirmModal = ({ isOpen, onClose, onConfirm, isRefunding }) => (
   <BasicModal
      isModalOpen={isOpen}
      handleCancel={isRefunding ? undefined : onClose}
      className="buy-funds"
   >
      <div className="buy-funds__content">
         <h2 className="buy-funds__title">Refund transaction</h2>

         <p className="buy-funds__description">
            Are you sure you want to refund this transaction? This action cannot be undone.
         </p>

         <div className="buy-funds__actions">
            <Button className="defaultButton" onClick={onClose} disabled={isRefunding}>
               Cancel
            </Button>
            <Button
               danger
               type="primary"
               className="buy-funds__refund-confirm"
               loading={isRefunding}
               onClick={onConfirm}
            >
               Yes, refund
            </Button>
         </div>
      </div>
   </BasicModal>
);

export default RefundConfirmModal;
